import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./AccessRoleUIHelpers";

const AccessRoleUIContext = createContext();

export function useAccessRoleUIContext() {
  return useContext(AccessRoleUIContext);
}

export const AccessRoleUIConsumer = AccessRoleUIContext.Consumer;

export function AccessRoleUIProvider({ accessRoleUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initAccessRole = {
    name: "",
    description: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initAccessRole,
    newAccessRoleButtonClick: accessRoleUIEvents.newAccessRoleButtonClick,
    openEditAccessRolePage: accessRoleUIEvents.openEditAccessRolePage,
    openAccessRoleFilePage: accessRoleUIEvents.openAccessRoleFilePage
  };

  return (
    <AccessRoleUIContext.Provider value={value}>
      {children}
    </AccessRoleUIContext.Provider>
  );
}
